<template>
  <div id="stock-list" class="list">
    <div class="stock-list-header list-header">
      <ul>
        <li>{{$_('reference')}}</li>
        <li>{{$_('designation')}}</li>
        <li>{{$_('size')}}</li>
        <li>{{$_('color')}}</li>
        <li>{{$_('packaging')}}</li>
        <li>{{$_('availability')}}</li>
        <li>{{$_('quantity_available')}}</li>
        <li>{{$_('in_production')}}</li>
        <li>{{$_('availability_date')}}</li>
        <li>{{$_('add_to_cart').toLowerCase()}}</li>
        <li>{{$_('price')}}</li>
      </ul>
    </div>
    <div class="stock-list-body list-body" v-if="items.length > 0">
      <div v-for="(item, index) in items" :key="index">
        <StockLine :dataline="item" :index="index" />
      </div>
    </div>
    <div v-else>
      <div class="stock-list-footer no-result">
        <span>{{$_('no_result')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import stockService from "../services/stockService";

import StockLine from "@/modules/stock/components/StockLine";

export default {
  name: "StockList",
  components: {
    StockLine
  },
  computed: {
    getResearch() {
      return this.$store.getters["stock/get_research"];
    }
  },
  data() {
    return {
      items: [],
      nResult: 0
    };
  },
  created() {
    this.getStock();
  },
  methods: {
    getStock() {

      this.items = Array();

      return stockService
        .getStock({
          pmod:
            this.$store.getters["stock/get_fmod"] !== ""
              ? this.$store.getters["stock/get_fmod"]
              : null,
          ptail:
            this.$store.getters["stock/get_ptail"] !== ""
              ? this.$store.getters["stock/get_ptail"]
              : null,
          pcol:
            this.$store.getters["stock/get_pcol"] !== ""
              ? this.$store.getters["stock/get_pcol"]
              : null
        })
        .then(res => {
          if (res.data.DS_O !== undefined) {
            res.data.DS_O.OUT.map(obj => {
              this.items.push(obj);
            });
            this.nResult = res.data.NB_RECORD;
            this.$store.dispatch("stock/LAUNCH_RESEARCH", { launch: false });
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  watch: {
    getResearch(value) {
      if (value === true) {
        this.getStock();
      }
    }
  }
};
</script>

<style scoped>
#stock-list {
  padding: 0px 0px;
}
.stock-list-header ul {
  display: flex;
}
.stock-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 10);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.stock-list-header {
  padding: 15px 0px;
}
.no-result {
  text-align: center;
  padding: 20px;
  border: solid 1px #e9e9e9;
  margin-bottom: 20px;
}
.no-result span {
  color: #8B8B8B;
}
</style>